import * as yup from 'yup'

import { trimmedInputValues, capitalizeWordsInValue } from '../utils';


const ReplacementItemValidationSchema = yup.object().shape({
    companyProdName: yup.string()
        .transform((value) => capitalizeWordsInValue(value))
        .min(3, 'Product name must be at least 3 characters')
        .required('Please enter product name')
        .transform((value) => trimmedInputValues(value)),
    companyProdSpec: yup.string()
        .transform((value) => capitalizeWordsInValue(value))
        .min(3, 'Product specification must be at least 3 characters')
        .required('Please enter product specification')
        .transform((value) => trimmedInputValues(value)),
    HSNCode: yup.string()
        .transform((value) => trimmedInputValues(value))
        .required('Please enter hsn code'),
    GSTRate: yup.string()
        .transform((value) => trimmedInputValues(value))
        .required('Please enter gst'),
    qty: yup.string()
        .transform((value) => trimmedInputValues(value))
        .required('Please enter qty'),
    UOM: yup.string()
        .transform((value) => trimmedInputValues(value))
        .required('Please select UOM'),
    unitPrice: yup.string()
        .transform((value) => trimmedInputValues(value))
        .required('Please enter unit price'),
    totalAmount: yup.string()
        .transform((value) => trimmedInputValues(value))
        .required('Please enter totalAmount')
})


const replacementItemInitialState = {
    productName: '',
    productSpecification: '',
    HSNCode: '',
    GSTRate: '',
    qty: null,
    UOM: "",
    unitPrice: null,
    totalAmount: null,
}


export { ReplacementItemValidationSchema, replacementItemInitialState }; 